var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.82 3.00001C13.82 2.79956 13.7003 2.61849 13.5159 2.53997C13.3314 2.46145 13.1179 2.50066 12.9734 2.6396L11.1955 4.34917C8.54827 6.89458 6.31144 9.83479 4.56461 13.0651C4.52348 13.1378 4.5 13.2217 4.5 13.3112C4.5 13.5873 4.72386 13.8112 5 13.8112H9.31V21C9.31 21.198 9.42684 21.3774 9.60795 21.4574C9.78907 21.5374 10.0003 21.503 10.1467 21.3696L10.9422 20.645C13.7269 18.1083 16.0902 15.1446 17.9432 11.865L18.4353 10.9942C18.5228 10.8394 18.5215 10.6498 18.4318 10.4962C18.3422 10.3426 18.1778 10.2482 18 10.2482H13.82V3.00001Z",
    fill: "#FFB700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarVerified);
export default __webpack_public_path__ + "static/media/avatar_verified.dc28e974db632f2430399c1627587f91.svg";
export { ForwardRef as ReactComponent };